<template>
  <v-main>
    <v-container fluid style="max-width: 400px;" class="pa-0 pt-0">
      <vue-headful title="Team" description="Aimz"/>
      <header1 class="mt-10">Team</header1>
      <v-row class="ml-5 mt-5" style="min-height: 40px;" v-if="changed">
        <v-btn dark @click="save">Speichern</v-btn>
        <v-btn class="ml-3" @click="load">Abbrechen</v-btn>
      </v-row>
      <v-progress-linear v-if="loading" class="mr-10" indeterminate></v-progress-linear>
      <v-alert type="error" v-if="error">{{ reason }}</v-alert>
      <v-col class="mx-2 mt-3">
        <p class="body-2">
          Bitte die Email-Adressen aller unmittelbaren Mitglieder des Teams eingeben. Für untergeordnete Teams
          bitte die Email des Teamleiters angeben.
        </p>
        <p>
          Neue Mitglieder werden beim Speichern automatisch eingeladen.
        </p>
        <div class="d-flex" v-for="(item,i) in members">
          <p>
            <v-icon class="mr-3">mdi-account-check</v-icon>
<!--            <span><router-link :to="'/team_member/'+item.email">{{item.email}}</router-link></span>-->
            <span>{{item.email}}</span>
          </p>
        </div>
        <div class="d-flex" v-for="(item,i) in invited">
          <v-text-field class="ml-0" v-model="item.email" :label="'Email '+(i+1)" :key="i"
                        prepend-icon="mdi-email" :rules="emailRules"/>
          <!--            <v-btn v-if="item.email" @click="onInviteAgain(item.email)" class="ml-3 mt-3">-->
          <!--              <v-icon>mdi-account-plus-outline</v-icon>-->
          <!--            </v-btn>-->
        </div>
      </v-col>
    </v-container>
  </v-main>
</template>

<script>
import Vue from "vue";
import CenterContainer from "@/components/CenterContainer";
import Header1 from "@/components/Header1";
import Lib from "@/components/ActivityLibrary";
import UserLib from "@/components/UserLib";
import {ArrayX} from "@/reusable/array_extensions";

const SETTINGS_CONTEXT = "@team";

export default {
  name: 'TeamSettings',
  components: {CenterContainer, Header1},
  data() {
    return {
      emailRules: [
        v => /.+@.+/.test(v) || 'Ungültige Email',
      ],
      settings: {},
      settings_edited: {
        members: [{email:undefined}],
      },
      loading: false,
      reason: '',
      error: false,
      changed: false,
      //dayOptions: [Lib.INPUT_MO, Lib.INPUT_DI, Lib.INPUT_MI, Lib.INPUT_DO, Lib.INPUT_FR, Lib.INPUT_SA, Lib.INPUT_SO],
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$app.setIntern();
      this.loading = true;
      this.$backend.get_settings(SETTINGS_CONTEXT, {onSuccess: this.onLoadSuccess, onError: this.onLoadError});
    },
    onLoadSuccess(data) {
      this.loading = false;
      console.log("data", data);
      data ||= {};
      if (!data.members || data.members.length==0 || !data.members[0] || !data.members[0].email)
        data.members= [{email:undefined}];
      console.log("data1", data);
      this.settings = data;
      this.settings_edited = JSON.parse(JSON.stringify(data));
      this.updateEmails();

      this.$nextTick(()=> this.changed=false);
    },
    onLoadError(reason) {
      this.loading = false;
      this.settings = {members: [{email:undefined}]};
      this.error = true;
      this.reason = reason;
      this.updateEmails();
      this.$nextTick(()=> this.changed=false);
    },
    save() {
      this.loading = true;
      this.$backend.set_settings(SETTINGS_CONTEXT, this.settings_edited, {
        onSuccess: this.onSaveSuccess,
        onError: this.onSaveError
      });
      this.load();
    },
    onSaveSuccess(data) {
      this.loading = false;
      this.settings = data;
      this.settings_edited = JSON.parse(JSON.stringify(data));
    },
    onSaveError(reason) {
      this.loading = false;
      this.error = true;
      this.reason = reason;
      this.load();
    },
    updateEmails(){
      var n=this.settings_edited;
      if (!n.members || n.members.length==0)
        this.$set(n, 'members', [{email:undefined}]);
      //console.log("last email:", n.members[n.members.length-1].email)
      if (n.members[n.members.length-1].email)
        n.members.push({email:undefined});
    },
    // onInviteAgain(email) {
    //   this.$backend.invite(email );
    // },
    isMember(status) {
      return status==UserLib.MemberJoined;
    }
  },
  computed: {
    members() {
      var settings_edited=this.settings_edited;
      if (!settings_edited && !settings_edited.members)
        return [];
      var items=settings_edited.members.filter(item => this.isMember(item.status));
      return new ArrayX(items).sortBy(x=>x.email);
    },
    invited() {
      var settings_edited=this.settings_edited;
      if (!settings_edited && !settings_edited.members)
        return [];
      var items=settings_edited.members.filter(item => this.isMember(item.status)==false);
      return items;
    },
  },
  watch: {
    settings_edited: {
      deep: true,
      handler(o, n) {
        this.updateEmails();
        this.changed = true;
      }
    }
  }
}
</script>

<style>
.rb {
  border: red 1px solid;
}

.full_width {
  width: 100%;
}
</style>